'use strict';
const recaptchaManager = require('od-modules/users/recaptcha.js');
const trackingUtils = require('od-modules/utils/tracking.utils');
const membershipRememberMeDescriptionFactory = require('components/membership/membership_remember_me_description/js/main');

module.exports = Odigeo.View.extend({
    errorMaxLength: 50,

    events: {
        'tap .freq_pass_newBtn': 'goToTappedNewPassenger',
        'tap .freq_pass_edit': 'goToTappedPassenger',
        'tap .login_button': 'login',
        'tap .passwordIcon': 'changePasswordCharsViewer',
        'tap .close_session': 'closeSession',
        'keyup .password_input': 'keyPressed',
        'focus .prisma_input_group': 'onFocusInput',
        'blur .prisma_input_group': 'onBlurInput',
    },

    selectors: {
        body: '.remember_me_passenger_body',
        passwordInput: '.password_input',
        loginSubmit: '.login_button',
        passwordIcon: '.password_icon',
        rememberLogout: '.remember_logout',
        rememberWelcome: '.remember_welcome',
        controlError: '.control_error',
        errorMessageWrapper: '.error_message_wrapper',
        recaptchaWrapper: '.g_recaptcha_remember_me',
        rememberMeError: '.remember_me_error',
        closeSession: '.close_session',
        prismaInput: '.prisma_input_group',
    },

    tmpls: {
        logoutTemplate: '.remember_me_widget_logout_template',
        descriptionTemplate: '.remember_me_widget_description_template',
        descriptionMemberTemplate: '.remember_me_widget_description_template_member',
    },

    init: function() {
        if (Odigeo.AB.isRecaptchaLoginEnabled) {
            if (recaptchaManager.isGRecaptchaLoaded) {
                this.renderCaptcha();
            } else {
                recaptchaManager.init();
            }
        }
        this.prepareKeys();
    },

    prepareKeys: function() {
        this.keys.loginRememberMePassengersWellComeBack =
            Odigeo.Utils.replaceCmsKeyArgs(this.keys.loginRememberMePassengersWellComeBack, this.model.name);
        this.keys.loginRememberMePassengersNotName =
            Odigeo.Utils.replaceCmsKeyArgs(this.keys.loginRememberMePassengersNotName, this.model.name);
    },

    renderSubTemplate: function() {
        this.$el.find(this.selectors.rememberLogout).empty().append(this.templates.rememberMeWidgetLogout({keys: this.keys}));

        if (this.model.membership) {
            membershipRememberMeDescriptionFactory.create({
                id: 'remember-welcome',
                options: {
                    userName: this.model.name,
                },
            });
        } else {
            this.$el.find(this.selectors.rememberWelcome).empty().append(this.templates.rememberMeWidgetDescription({keys: this.keys}));
        }
    },

    activateWidget: function(isActive) {
        this.$el.find(this.selectors.body).toggleClass('hidden', !isActive);
        if (isActive) {
            this.renderSubTemplate();
            trackingUtils.trackEvent('sso_pax_page', 'go_to_login_user_remembered');
            this.model.set('isActivated', isActive);
        }
    },

    keyPressed: function(e) {
        if ((e.keyCode ? e.keyCode : e.which) === 13) {
            this.login();
        }
    },

    login: function() {
        this.$el.find(this.selectors.errorMessageWrapper).removeClass('invalid invalid-long');
        if (this.checkPassword()) {
            trackingUtils.trackEventWithCategory('sso_module', 'sign_in', 'remember_me_clicks');
            this.model.recaptchaCallbackData = {
                login: this.model.mail,
                password: this.$el.find(this.selectors.passwordInput).val(),
                rememberme: true,
            };
            this.hideGenericError();
            if (Odigeo.AB.isRecaptchaLoginEnabled && this.model.recaptchaRendered) {
                recaptchaManager.gRecaptchaExecute(this.model.recaptchaWidgetID);
            } else {
                this.triggerSubmitRequest();
            }
        }
    },

    renderCaptcha: function() {
        if (Odigeo.AB.isRecaptchaLoginEnabled && !this.model.recaptchaRendered && this.model.get('isActivated')) {
            this.model.recaptchaWidgetID = recaptchaManager.gRecaptchaRender(this.$el.find(this.selectors.recaptchaWrapper).get(0),
                Odigeo._.bind(this.recaptchaExecutionCallback, this), Odigeo.UserArea.recaptchaSiteKey);
            this.model.recaptchaRendered = true;
        }
    },

    recaptchaExecutionCallback: function() {
        this.model.recaptchaCallbackData.recaptchaResponse = recaptchaManager.gRecaptchaGetResponse(this.model.recaptchaWidgetID);
        this.triggerSubmitRequest();
    },

    triggerSubmitRequest: function() {
        Odigeo.trigger(this.widget.id + ':submitUserRequest', {
            'data': this.model.recaptchaCallbackData,
            'action': 'login',
        });
    },

    checkPassword: function() {
        let errorLog = '';
        const value = this.$el.find(this.selectors.passwordInput).val();
        const valData = this.$el.find(this.selectors.passwordInput).data();

        if (Odigeo._.isEmpty(value)) {
            errorLog = 'empty';
        } else if (valData && valData.validationType && !Odigeo.Utils.isValid(valData.validationType, value)) {
            errorLog = 'invalid';
        }

        if (errorLog !== '') {
            this._showError(errorLog);
        }

        return errorLog === '';
    },

    launchAccountBlockedFlow: function() {
        Odigeo.Utils.eraseCookie('sso_remember_me');
        Odigeo.trigger(this.widget.id + ':submitUserRequest', {data: this.model.mail, action: 'recoverPassword'});
        Odigeo.Router.navigate('accountblocked');
    },

    changePasswordCharsViewer: function() {
        this.$el.find(this.selectors.passwordIcon).find('.password_char_viewer').toggleClass('hidden');
        this.$el.find(this.selectors.passwordInput).attr('type',
            this.$el.find(this.selectors.passwordInput).attr('type') === 'password' ? 'text' : 'password'
        );
    },

    closeSession: function(e) {
        e.preventDefault();
        this.widget.enableRememberMe(false);
        Odigeo.trigger(this.widget.id + ':submitUserRequest', {'data': '', 'action': 'logOut'});
    },

    _showError: function(error, isLongMessage) {
        const errText = this.$el.find(this.selectors.passwordInput).data((Odigeo._.isUndefined(error)) ? 'requesterror' : error);
        const isLongError = !Odigeo._.isUndefined(isLongMessage) ? !!isLongMessage : (errText.length > this.errorMaxLength);

        if (error !== 'requesterror') {
            this.$el.find(this.selectors.passwordInput).parent().addClass('invalid');
        }
        this.$el.find(this.selectors.errorMessageWrapper).addClass(isLongError ? 'invalid-long' : 'invalid');
        this.$el.find(this.selectors.errorMessageWrapper).find(isLongError ? '.error_long_message' : '.error_message').text(errText);
    },

    _showUnlError: function() {
        const texts = Odigeo.UIElements.translations.unl.lightboxTextsVelocityRules;
        Odigeo.UIElements.showLightboxWarning('od-passenger-lightbox-logout',
            Odigeo._.bind(Odigeo.trigger, Odigeo, 'closeAllPopUps'),
            Odigeo._.bind(Odigeo.trigger, Odigeo, 'closeAllPopUps'),
            Odigeo._.extend({}, texts, {description: texts.description}));
    },

    _isAccountBlocked: function(data) {
        return data && data.messageError && this.model.errors[data.messageError] === 'accountblocked';
    },

    hideGenericError: function() {
        this.$el.find(this.selectors.rememberMeError).addClass('odf-hidden');
    },

    onFocusInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).addClass('focused');
    },

    onBlurInput: function(e) {
        $(e.target).closest(this.selectors.prismaInput).removeClass('focused');
    },

    showGenericError: function(errAttr) {
        const rememberMeError = this.$el.find(this.selectors.rememberMeError);
        const err = rememberMeError.data(errAttr);

        rememberMeError.find('.msg-item').text(err);
        rememberMeError.removeClass('odf-hidden');
    },
});
